export interface CustomerRepresentative {
  name: string;
  personalCode: string;
}

export interface CustomerRepresentatives {
  boardMembers: CustomerRepresentative[];
  procurators: CustomerRepresentative[];
  authorizedRepresentatives: CustomerRepresentative[];
}

export enum RepresentativeRole {
  BOARD_MEMBER = 'BOARD_MEMBER',
  PROCURATOR = 'PROCURATOR',
  AUTHORIZED_REPRESENTATIVE = 'AUTHORIZED_REPRESENTATIVE'
}

export const REPRESENTATIVE_ROLE_MAP: { [key in RepresentativeRole]: string } = {
  BOARD_MEMBER: 'Juhatuse liige',
  PROCURATOR: 'Prokurist',
  AUTHORIZED_REPRESENTATIVE: 'Volitatud esindaja'
};

/** A representative flattened out of its role group, so all roles can be listed as one selectable list. */
export interface SelectableRepresentative extends CustomerRepresentative {
  role: RepresentativeRole;
}

export const EMPTY_CUSTOMER_REPRESENTATIVES: CustomerRepresentatives = {
  boardMembers: [],
  procurators: [],
  authorizedRepresentatives: []
};

export function toSelectableRepresentatives(
  representatives: CustomerRepresentatives
): SelectableRepresentative[] {
  const withRole = (
    people: CustomerRepresentative[],
    role: RepresentativeRole
  ) => people.map(person => ({ ...person, role }));

  return [
    ...withRole(representatives.boardMembers, RepresentativeRole.BOARD_MEMBER),
    ...withRole(representatives.procurators, RepresentativeRole.PROCURATOR),
    ...withRole(representatives.authorizedRepresentatives, RepresentativeRole.AUTHORIZED_REPRESENTATIVE)
  ];
}
